import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const keycloak = window.keycloak;
  const username = keycloak?.tokenParsed?.preferred_username;
  
  // Use Keycloak's built-in function to get the account URL dynamically
  const accountUrl = keycloak ? keycloak.createAccountUrl() : '#';

  return (
    <header className="header">
      <div className="top-row">
        <div className="brand-section">
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            ☰
          </button>

          <div className="brand">
            <div className="logo">
              <a
                href="https://currentjobs.co.ke/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                Currentjobs.co.ke
              </a>
            </div>
          </div>
        </div>

        {/* Account link and username */}
        {username && (
          <div className="user-section">
            <a
              href={accountUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMenuOpen(false)}
              className="account-link"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              {username}
            </a>
            <button
              onClick={() => keycloak.logout({ redirectUri: window.location.origin })}
              className="btn-secondary"
              style={{ padding: '0.375rem 0.75rem', fontSize: '0.75rem' }}
            >
              Logout
            </button>
          </div>
        )}
      </div>

      <nav className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
        <NavLink to="/" onClick={() => setMenuOpen(false)}>Dashboard</NavLink>
        <NavLink to="/add" onClick={() => setMenuOpen(false)}>Post Job</NavLink>
        <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>
        <NavLink to="/services" onClick={() => setMenuOpen(false)}>Services</NavLink>
        <NavLink to="/faq" onClick={() => setMenuOpen(false)}>FAQ</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</NavLink>
      </nav>
    </header>
  );
};

export default Header;
